var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "RefContract" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: { "item-key": "IsHero", error: _vm.$v.form.IsHero }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.IsHero
                        },
                        model: {
                          value: _vm.form.IsHero,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "IsHero", $$v)
                          },
                          expression: "form.IsHero"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.detail"), active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SourceCustomerId",
                            error: _vm.$v.form.SourceCustomerId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              searchable: true,
                              "custom-option": true,
                              "or-condition-fields":
                                "Code,Description1,CommercialTitle",
                              disabled: _vm.insertReadonly.SourceCustomerId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSourceCustomer(
                                  "SourceCustomerId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.sourceCustomer,
                              callback: function($$v) {
                                _vm.sourceCustomer = $$v
                              },
                              expression: "sourceCustomer"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TargetCustomerId",
                            error: _vm.$v.form.TargetCustomerId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              searchable: true,
                              "custom-option": true,
                              "or-condition-fields":
                                "Code,Description1,CommercialTitle",
                              disabled: _vm.insertReadonly.TargetCustomerId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "TargetCustomerId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ContractTransferStatusId",
                            error: _vm.$v.form.ContractTransferStatusId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.ContractTransferStatusId,
                              "lookup-key": "CONTRACT_TRANSFER_STATUS"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ContractTransferStatusId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SourceContractStartDate",
                            error: _vm.$v.form.SourceContractStartDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled:
                                _vm.insertReadonly.SourceContractStartDate
                            },
                            model: {
                              value: _vm.form.SourceContractStartDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "SourceContractStartDate",
                                  $$v
                                )
                              },
                              expression: "form.SourceContractStartDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SourceContractEndDate",
                            error: _vm.$v.form.SourceContractEndDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.SourceContractEndDate
                            },
                            model: {
                              value: _vm.form.SourceContractEndDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SourceContractEndDate", $$v)
                              },
                              expression: "form.SourceContractEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "TransferReasonId",
                            error: _vm.$v.form.TransferReasonId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.TransferReasonId,
                              "lookup-key": "TRANSFER_REASON"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "TransferReasonId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SourceContractId",
                            error: _vm.$v.form.SourceContractId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.sourceContracts,
                              disabled: _vm.insertReadonly.SourceContractId,
                              label: "Contract"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSourceContract(
                                  "SourceContractId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.sourceContract,
                              callback: function($$v) {
                                _vm.sourceContract = $$v
                              },
                              expression: "sourceContract"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.contractDetail
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-table", {
                                attrs: {
                                  items: _vm.contractDetail,
                                  fields: _vm.fields,
                                  striped: "",
                                  responsive: "",
                                  "sticky-header": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "head()",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t(data.label)) +
                                              "\n              "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  1844599052
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0167bd32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0167bd32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RefContract/insert.vue
// module id = null
// module chunks = 